export default {
  fontMoreActionsPanel: {
    display: 'inline-block',
    '@media (min-width: 1250px)': {
      display: 'none'
    }
  },
  fontEmphasisAndAlign: {
    display: 'none',
    '@media (min-width: 1250px)': {
      display: 'inline-block'
    }
  }
};

